module.exports = __webpack_public_path__ + "static/media/country_sk.4bfe9094.webp";